import axios from 'axios';

/*
*  This file contains all axios calls related to unpublish  on CB
*/

export const unpublish = async (funnelId, unpublishedFormMessage) => {
    await axios.put(`/app/funnel/${funnelId}/unpublish`, unpublishedFormMessage);
};
